import { hasPermission } from '../../lib/permissions.ts';
import type { NavItemPermission } from './navItemAccess.ts';

/** Whether a sidebar (or route) item is visible for the given permission codes. */
export function navItemVisible(
  item: { permission?: NavItemPermission },
  permissions: string[],
  schoolId?: string,
): boolean {
  if (!item.permission) return true;
  return navPermissionHeld(item.permission, permissions, schoolId);
}

export function navPermissionHeld(
  permission: NavItemPermission,
  permissions: string[],
  schoolId?: string,
): boolean {
  const actions = Array.isArray(permission.action) ? permission.action : [permission.action];
  return actions.some((action) => hasPermission(permissions, permission.resource, action, schoolId));
}

export function visibleNavItemNames(
  items: { name: string; permission?: NavItemPermission }[],
  permissions: string[],
  schoolId?: string,
): string[] {
  return items.filter((item) => navItemVisible(item, permissions, schoolId)).map((item) => item.name);
}
